const appMapping = {
  "www.videograbber.net": "videograbber web all",
  "myaccount.apowersoft.cn": "myaccount-apowersoft web china",
  "myaccount.apowersoft.com": "myaccount-apowersoft web overseas",
  "myaccountm.apowersoft.com": "myaccount-apowersoft wap overseas",
  "myaccountm.apowersoft.cn": "myaccount-apowersoft wap china",
  "www.apowersoft.com": "apowersoft web overseas",
  "www.apowersoft.cn": "apowersoft web china",
};
function getAppName() {
  return appMapping[window.location.host] || "apowersoft web overseas";
}

export default {
  accountApiBaseUrl: "https://gw.aoscdn.com/base/passport/v1/api",
  // supportApiBaseUrl: "https://support.aoscdn.com/api",
  supportApiBaseUrl: "https://gw.aoscdn.com/base/payment",
  aimageApiBaseUrl: "https://apiaimage.aoscdn.com/api",
  fileApiBaseUrl: "https://file.aoscdn.com/api",
  storageApiBaseUrl: "https://storage.aoscdn.com/api",
  agentApiBaseUrl: "https://gw.aoscdn.com/base/support",
  vipApiBaseUrl: "https://gw.aoscdn.com/base/vip",
  myaccountAppName: getAppName(),
  timeout: 5000,
};
